import { createSlice } from "@reduxjs/toolkit"
import { getAppMetaDataShowrooms, ShowRoomSlimDto } from "api"
import { createAsyncAppThunk } from "store/thunkHelpers"

const name = "showRooms"

type ShowRoomsState = {
  showRooms: ShowRoomSlimDto[]
}

const initialState: ShowRoomsState = {
  showRooms: [],
}

export const fetchShowRooms = createAsyncAppThunk(
  `${name}/fetchShowRooms`,
  async () => {
    const { data } = await getAppMetaDataShowrooms()
    return data.body
  }
)

const showRooms = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchShowRooms.fulfilled, (state, { payload }) => {
      state.showRooms = payload
    })
  },
})

export default showRooms.reducer
